"use client";

import { useState } from "react";
import { ChevronLeft, ChevronRight, ArrowRight, Eye } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const filters = [{
  id: "all",
  label: "All"
}, {
  id: "highlights",
  label: "Highlights"
}, {
  id: "victories",
  label: "Victories"
}, {
  id: "merch",
  label: "Merchandise"
}, {
  id: "roster",
  label: "Roster"
}, {
  id: "community",
  label: "Community"
}];
const products = [{
  id: 1,
  category: "Highlights",
  name: "Live Stream Clutch",
  price: "WATCH",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/stream_clutch.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/stream_clutch.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/stream_clutch.png-wvc-sizes",
    alt: "Live stream highlight capture"
  },
  filter: "highlights"
}, {
  id: 2,
  category: "Victories",
  name: "Tournament Finals Win",
  price: "REPLAY",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/tournament_win.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/tournament_win.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/tournament_win.png-wvc-sizes",
    alt: "Tournament victory celebration"
  },
  filter: "victories"
}, {
  id: 3,
  category: "Merchandise",
  name: "Pixel Force Jersey",
  price: "$85",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/team_jersey.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/team_jersey.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/team_jersey.png-wvc-sizes",
    alt: "Official team jersey"
  },
  filter: "merch"
}, {
  id: 4,
  category: "Roster",
  name: "Pro Player Profile",
  price: "VIEW",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/pro_player.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/pro_player.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/pro_player.png-wvc-sizes",
    alt: "Professional esports player"
  },
  filter: "roster"
}, {
  id: 5,
  category: "Community",
  name: "Discord Hub Access",
  price: "JOIN",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/discord_hub.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/discord_hub.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/discord_hub.png-wvc-sizes",
    alt: "Community discord hub"
  },
  filter: "community"
}, {
  id: 6,
  category: "Highlights",
  name: "Weekly Top Plays",
  price: "WATCH",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/weekly_plays.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/weekly_plays.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/weekly_plays.webp-wvc-sizes",
    alt: "Weekly top plays compilation"
  },
  filter: "highlights"
}, {
  id: 7,
  category: "Victories",
  name: "Regional Championship",
  price: "REPLAY",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/regional_win.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/regional_win.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/regional_win.png-wvc-sizes",
    alt: "Regional championship trophy"
  },
  filter: "victories"
}, {
  id: 8,
  category: "Merchandise",
  name: "Tactical Hoodie",
  price: "$120",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/tactical_hoodie.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/tactical_hoodie.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/tactical_hoodie.png-wvc-sizes",
    alt: "Official tactical hoodie"
  },
  filter: "merch"
}, {
  id: 9,
  category: "Community",
  name: "Wallpaper Pack",
  price: "DOWNLOAD",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/wallpaper_pack.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/wallpaper_pack.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/wallpaper_pack.webp-wvc-sizes",
    alt: "High-res desktop wallpapers"
  },
  filter: "community"
}];
export default function TheArmory() {
  const [activeFilter, setActiveFilter] = useState("all");
  const [sortBy, setSortBy] = useState("featured");
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const filteredProducts = activeFilter === "all" ? products : products.filter(p => p.filter === activeFilter);
  return <section data-section-id="3967" id="the-armory" className="bg-background text-foreground py-20 md:py-28 px-4 md:px-8 lg:px-12">
      <div className="max-w-7xl mx-auto">
        <div ref={headerRef} className={`mb-12 md:mb-16 transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-muted-foreground mb-4">
            Pixel Force — Command Center
          </p>
          <h2 className="font-default font-bold text-4xl md:text-6xl lg:text-7xl uppercase tracking-tight leading-none">
            The Armory
          </h2>
        </div>

        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6 mb-10 md:mb-14 pb-6 border-b border-border">
          <div className="flex flex-wrap gap-2 md:gap-3">
            {filters.map((filter, i) => <Button key={filter.id} data-index={i} onClick={() => setActiveFilter(filter.id)} variant="outline" className={`font-default text-[12px] uppercase tracking-[0.2em] px-4 py-2.5 backdrop-blur-md transition-all duration-300 h-auto ${activeFilter === filter.id ? "border-primary text-primary bg-primary/10 shadow-lg" : "border-border text-muted-foreground bg-card/40 hover:text-foreground hover:border-foreground/40"}`}>
                {filter.label}
              </Button>)}
          </div>

          <div className="flex items-center gap-3">
            <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-muted-foreground">
              Sort
            </span>
            <Select value={sortBy} onValueChange={setSortBy}>
              <SelectTrigger className="w-[180px] font-default text-[12px] uppercase tracking-[0.2em] bg-card/40 backdrop-blur-md border-border h-11">
                <SelectValue />
              </SelectTrigger>
              <SelectContent className="bg-popover border-border">
                <SelectItem value="featured" className="font-default text-[12px] uppercase tracking-[0.2em]">
                  Featured
                </SelectItem>
                <SelectItem value="newest" className="font-default text-[12px] uppercase tracking-[0.2em]">
                  Newest
                </SelectItem>
                <SelectItem value="price-low" className="font-default text-[12px] uppercase tracking-[0.2em]">
                  Price: Low to High
                </SelectItem>
                <SelectItem value="price-high" className="font-default text-[12px] uppercase tracking-[0.2em]">
                  Price: High to Low
                </SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredProducts.map((product, i) => <article key={product.id} data-index={i} className="group relative bg-card/30 backdrop-blur-xl border border-border shadow-2xl hover:shadow-4xl hover:-translate-y-1 transition-all duration-500 ease-out overflow-hidden">
              <div className="relative aspect-square overflow-hidden bg-muted/30">
                <img src={product.image.src} data-wvc-srcset={product.image.srcset} data-wvc-sizes={product.image.sizes} alt={product.image.alt} loading="lazy" decoding="async" className="w-full h-full object-cover grayscale transition-transform duration-700 ease-out group-hover:scale-105" />

                <div className="absolute inset-x-0 bottom-0 translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out">
                  <Button className="w-full h-12 bg-primary text-primary-foreground hover:bg-primary/90 font-default text-[12px] uppercase tracking-[0.25em]">
                    <Eye className="w-4 h-4" />
                    Access
                  </Button>
                </div>
              </div>

              <div className="p-6 space-y-3">
                <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-muted-foreground">
                  {product.category}
                </p>
                <h3 className="font-default font-semibold text-xl uppercase tracking-tight leading-tight">
                  {product.name}
                </h3>
                <div className="flex items-center justify-between pt-2">
                  <p className="font-default font-bold text-lg text-primary">
                    {product.price}
                  </p>
                </div>
                <div className="pt-3 border-t border-border">
                  <Button variant="ghost" className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.25em] text-muted-foreground hover:text-foreground transition-colors duration-300 h-auto p-0">
                    Add to Queue
                    <ArrowRight className="w-3.5 h-3.5 transition-transform duration-300 group-hover:translate-x-1" />
                  </Button>
                </div>
              </div>
            </article>)}
        </div>

        <div className="mt-16 md:mt-20 pt-8 border-t border-border flex flex-col sm:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-2">
            <span className="font-mono text-2xl md:text-3xl font-light text-foreground">
              01
            </span>
            <span className="font-mono text-2xl md:text-3xl font-light text-muted-foreground">
              /
            </span>
            <span className="font-mono text-2xl md:text-3xl font-light text-muted-foreground">
              04
            </span>
          </div>

          <div className="flex items-center gap-3">
            {[1, 2, 3, 4].map((page, i) => <Button key={page} data-index={i} variant="ghost" aria-label={`Page ${page}`} className={`w-2 h-2 p-0 transition-all duration-300 ${page === 1 ? "bg-primary w-8" : "bg-muted-foreground/40 hover:bg-foreground"}`} />)}
          </div>

          <div className="flex items-center gap-2">
            <Button variant="outline" size="icon" className="h-11 w-11 border-border bg-card/40 backdrop-blur-md hover:bg-primary hover:text-primary-foreground hover:border-primary" aria-label="Previous page">
              <ChevronLeft className="w-4 h-4" />
            </Button>
            <Button variant="outline" size="icon" className="h-11 w-11 border-border bg-card/40 backdrop-blur-md hover:bg-primary hover:text-primary-foreground hover:border-primary" aria-label="Next page">
              <ChevronRight className="w-4 h-4" />
            </Button>
          </div>
        </div>
      </div>
    </section>;
}